<template>
	<div class="configPage">
		<!-- 插件启用状态 -->
		<el-row class="config" type="flex" v-loading="mainLoading">
			<div class="languageList_body">
				<div class="languageList_top">
					<div class="languageList_left">
						<span class="text">插件启用状态</span>
						<span class="tips"
							>插件启用状态更改后，需要几分钟时间生效；显示为“配置中”时，可联系服务人员了解详情</span
						>
					</div>
					<el-switch
						:active-value="1"
						:inactive-value="0"
						v-model="switchStatus"
						@change="setMainSwitch"
					></el-switch>
				</div>
				<languages :Language="languageList" @query="getdataplug"></languages>
			</div>
		</el-row>

		<!-- 切换Tab -->
		<div class="config_tab_list">
			<sky-tabs v-model="tabValue" :tabList="tabList"></sky-tabs>
		</div>

		<div class="config_tab_body">
			<component :is="tabValue" :configInfo="configInfo" @emitData="emitData"></component>
		</div>

		<!-- 配置发布 -->
		<div class="publish" v-if="tabValue !== 'AIautoReplyConfig'">
			<el-row class="prompt" type="flex">
				<el-col :span="24">
					<span class="tip">
						<span v-show="showtips">您有未发布的内容，点击发布后生效</span>
						<span @click="Reset" class="interval">
							<el-button size="medium" :loading="resetBtnLoading">重置</el-button>
						</span>
						<span @click="publishconfig">
							<el-button type="primary" size="medium" :loading="isload">发布</el-button>
						</span>
					</span>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import languages from '@/backend/pages/socialMedia/Languages.vue';
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs-custom.vue';
import plugInStyle from './plugInStyle.vue';
import autoReplyConfig from './autoReplyConfig.vue';
import AIautoReplyConfig from './AIautoReplyConfig.vue';

import chat from '@/backend/services/account/chat.js';

export default {
	components: {
		languages,
		skyTabs,
		plugInStyle,
		autoReplyConfig,
		AIautoReplyConfig,
	},
	data() {
		return {
			switchStatus: 0,
			configInfo: null,
			languageList: [],
			tabValue: 'plugInStyle',
			resetBtnLoading: false,
			isload: false,
			showtips: false,
			mainLoading: false,
		};
	},
	computed: {
		getserviceId: function () {
			let serviceId = this.$route.query.serviceSiteId;
			return serviceId;
		},

		getcustomerId: function () {
			let customerId = this.$route.query.customerId;
			return customerId;
		},

		gettpageId: function () {
			let tpageId = this.$route.query.tpageId;
			return tpageId;
		},
		tabList(self) {
			let isConfigAutoReply = self.$route.query.isConfigAutoReply;
			return [
				{
					label: '插件样式',
					name: 'plugInStyle',
				},
				isConfigAutoReply
					? {
							label: 'AI自动回复设置',
							name: 'AIautoReplyConfig',
					  }
					: {
							label: '自动回复设置',
							name: 'autoReplyConfig',
					  },
			];
		},
	},
	mounted() {
		this.getMainSwitchstatus();
		this.getdataplug();
		this.getfbconfig();
	},
	methods: {
		//获取插件启动状态列表
		async getdataplug() {
			let plugid = this.getserviceId;
			let res = await chat.getallconfig({ serviceSiteId: plugid });
			this.languageList = res.data;
			this.getMainSwitchstatus();
		},
		//获取插件总开关状态
		async getMainSwitchstatus() {
			let plugid = this.getserviceId;
			let res = await chat.getMainSwitchstatus({ serviceSiteId: plugid });
			this.switchStatus = res.data || 0;
		},
		//开关或关闭总开关
		async setMainSwitch(switchStatus) {
			this.mainLoading = true;

			let plugid = this.getserviceId;
			await chat.setMainSwitch({ serviceSiteId: plugid, switchStatus });
			this.getdataplug();
			this.mainLoading = false;
		},
		//  获取配置页信息
		async getfbconfig() {
			let res = await chat.getfbconfig({
				serviceId: this.getserviceId,
				customerId: this.getcustomerId,
				tpageId: this.gettpageId,
			});
			if (res && res.data) {
				let { data } = res;
				let { releaseStatus } = data;
				if (releaseStatus === 0 || releaseStatus === 2) this.showtips = true;
				else this.showtips = false;
				this.configInfo = data;
			}
		},
		// 处理提交上来的数据
		emitData() {
			this.getfbconfig();
		},
		//配置页面重置
		async Reset() {
			this.resetBtnLoading = true;
			let { configInfo } = this;
			let { id } = configInfo;
			let res = await chat.configReset({
				serviceSiteId: this.getserviceId,
				id,
			});
			if (res.data == 'success') {
				this.getfbconfig();

				this.showtips = false;
			} else {
				this.fail('重置失败');
			}
			this.resetBtnLoading = false;
		},
		// 发布前保存
		async Savepublic() {
			let { configInfo } = this;
			await chat.getfabasic({
				serviceSiteId: this.getserviceId,
				customerId: this.getcustomerId,
				...configInfo,
			});
		},
		//配置发布
		publishconfig() {
			this.isload = true;
			let customerid = this.getcustomerId;
			let serviceid = this.getserviceId;
			let tpageid = this.gettpageId;
			this.Savepublic().then(async () => {
				await chat
					.publishconfig({
						serviceId: serviceid,
						customerId: customerid,
						tpageId: tpageid,
					})
					.then(res => {
						if (res.data === 'success') {
							this.success('发布成功,您的更改已生效！');
							this.showtips = false;
						} else {
							this.fail('发布失败,请重新编辑发布！');
						}
						this.isload = false;
					})
					.catch(err => {
						this.isload = false;
					});
			});
		},
		success: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'success',
			});
		},
		fail: function (str) {
			this.$message({
				showClose: true,
				message: str,
				type: 'error',
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.configPage {
	.config,
	.config_tab_list {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
	}

	.config {
		margin-bottom: 20px;
	}

	.languageList_body {
		width: 100%;

		.languageList_top {
			display: flex;
			padding: 20px;
			border-bottom: 1px solid #e8e8e8;
			justify-content: space-between;

			.languageList_left {
				.text {
					font-size: 16px;
					color: #333;
					font-weight: bold;
				}

				.tips {
					font-size: 13px;
					margin-left: 20px;
					font-weight: 400;
					color: #999;
				}
			}
		}
	}

	.config_tab_list {
		padding: 15px 30px;
		border-bottom: 1px solid #e8e8e8;
	}

	.config_tab_body {
		margin-bottom: 20px;
	}

	.publish {
		position: fixed;
		position: sticky;
		bottom: 0;
		width: 100%;
		z-index: 999;

		.prompt {
			box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
			border-radius: 4px;
			background-color: #fff;
			height: 70px;
			position: relative;

			.tip {
				position: absolute;
				font-size: 13px;
				font-weight: 400;
				right: 25px;
				top: 75%;
				margin-top: -35px;
				color: #999;

				.interval {
					margin: 0 10px;
				}
			}
		}
	}
}
</style>
